import { useEffect, useState } from "react"; 
import MultipleSelectList from "./Default/MultipleSelectList"; 
import jobsData from "../data/jobs.json";

export default function JobsList({ inputClass, value, setValue, required = true }) {
    const [jobsOptions, setJobsOptions] = useState([]);
    
    useEffect(() => {
        const options = jobsData
            .filter((item) => typeof item === "string" && item.trim() !== "")
            .map((item) => ({ value: item, label: item }));

        const sortedOptions = options.sort((a, b) =>
            a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
        );
        setJobsOptions(sortedOptions);
    }, []);

    return (
        <div className={inputClass}>
            <MultipleSelectList
                options={jobsOptions}
                value={value}
                setValue={setValue}
                className={inputClass}
                defaultText="Выберите профессии..."
                required={required}
            />
        </div>
    );
}
